"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInheritedGroups = void 0;
const authApiClient_types_1 = require("root/src/server/util/awsClients/authApiClient.types");
const auth_1 = require("root/src/shared/constants/auth");
const getInheritedGroups = (groups) => {
    const baseGroups = groups || [authApiClient_types_1.AuthGroup.User];
    const groupsInherited = [];
    while (baseGroups.length > 0) {
        const currentKey = baseGroups.pop();
        groupsInherited.push(currentKey);
        const children = auth_1.groupsPrecedence[currentKey];
        if (children) {
            children.forEach((child) => {
                baseGroups.push(child);
            });
        }
    }
    return [...new Set(groupsInherited)];
};
exports.getInheritedGroups = getInheritedGroups;
